import { render, staticRenderFns } from "./CuadroGestionCobro.vue?vue&type=template&id=4d4f6e1a&scoped=true"
import script from "./CuadroGestionCobro.vue?vue&type=script&lang=js"
export * from "./CuadroGestionCobro.vue?vue&type=script&lang=js"
import style0 from "./CuadroGestionCobro.vue?vue&type=style&index=0&id=4d4f6e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4f6e1a",
  null
  
)

export default component.exports